// --- 统计管理 --- //

export default [
  {
    name: "reportSystem",
    path: "/supplySystem/:supplyId/reportSystem",
    meta: { title: "报表系统" },
    component:
      require("business/supplySystem/statisticsManagement/reportSystem/list.vue")
        .default,
  },
  {
    name: "statisticsAnalysis",
    path: "/supplySystem/:supplyId/statisticsAnalysis",
    meta: { title: "统计分析" },
    component:
      require("business/supplySystem/statisticsManagement/statisticsAnalysis/list.vue")
        .default,
  },
  {
    name: "statisticsReport",
    path: "/supplySystem/:supplyId/statisticsReport",
    meta: { title: "统计报表" },
    component:
      require("business/supplySystem/statisticsManagement/statisticsReport/list.vue")
        .default,
  },
  {
    name: "statisticsSurvey",
    path: "/supplySystem/:supplyId/statisticsSurvey",
    meta: { title: "调查问卷统计报表" },
    component:
      require("business/supplySystem/statisticsManagement/statisticsSurvey/list.vue")
        .default,
  },
  {
    name: "surveyFeedback",
    path: "/supplySystem/:supplyId/statisticsSurvey/surveyFeedback",
    meta: { title: "调查问卷建议反馈" },
    component:
      require("business/supplySystem/statisticsManagement/statisticsSurvey/feedback.vue")
        .default,
  },
];
